// What Carli is allowed to do with an upload. Permissions are granted by
// default; brands withdraw the ones their agreements don't cover.
export type PermissionId = 'paidSocial' | 'paidFeeds' | 'lifecycle' | 'brandIdentity' | 'brandImagery'

export type Permission = {
  id: PermissionId
  label: string
  detail: string
  impact: string
}

export const promotionPermissions: Permission[] = [
  {
    id: 'paidSocial',
    label: 'Paid social',
    detail: 'Paid placements across social platforms.',
    impact: 'Reduces reach on discovery-driven categories where social carries most of the volume.',
  },
  {
    id: 'paidFeeds',
    label: 'Paid product feeds',
    detail: 'Paid product and catalog placements across supported advertising channels.',
    impact: 'Removes the highest-intent paid traffic source. Free organic feed listings continue.',
  },
  {
    id: 'lifecycle',
    label: 'Email & SMS',
    detail: 'Email, SMS, newsletters, and lifecycle marketing.',
    impact: 'Removes the lowest-cost recovery channel. Small reach effect, outsized margin effect.',
  },
  {
    id: 'brandIdentity',
    label: 'Brand name & logos',
    detail: 'Use the brand name and logos in advertising headlines, promotional copy, and creative.',
    impact: 'Unbranded promotion converts lower, so cost per unit recovered rises.',
  },
  {
    id: 'brandImagery',
    label: 'Product & campaign imagery',
    detail: 'Use the product photography supplied with the inventory, plus lifestyle and campaign assets.',
    impact: 'Listings go live more slowly and convert lower until Carli produces replacement photography.',
  },
]
